<svg [style.width]="width" viewBox="0 0 721 565" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    #animatedPath
    [attr.stroke]="color"
    stroke-width="60"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
